<template>
  <v-card elevation="0" height="150px">
    <v-row class="pa-0 ma-0">
      <v-col xl="8" lg="9" md="9" sm="10" cols="12">
        <mb-select
          v-model="val"
          :items="serviceChannels"
          itemText="description"
          itemValue="id"
          returnObject
          name="cf_serviceChannel"
          label="Forma de Atendimento"
          :loading="loading"
          @input="$emit('input', val)"
        />
      </v-col>
    </v-row>
    <!-- Buttons -->
    <v-row class="pa-0 ma-0 ml-3">
      <v-col xl="3" lg="3" md="3" sm="3" cols="12" class="pa-0 ma-0">
        <mb-text-button name="cf_sc_continue" label="Continuar"
          @click="$emit('click')" :primary="false" />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import MbSelect from '@/components/general/inputs/MbSelect';
import MbTextButton from '@/components/general/buttons/MbTextButton';

export default {
  props: {
    value: {
      type: Object,
    },
  },
  data: () => ({
    val: {id: -1, description: 'Atendimento presencial'},
    loading: false,
    serviceChannels: [],
  }),
  computed: {
    user() {
      return this.$store.getters['auth/getUser'];
    },
  },
  created() {
    this.val = this.value;
    this.getServiceChannels();
  },
  methods: {
    getServiceChannels() {
      this.loading = true;
      this.$store.dispatch('serviceChannel/all')
        .then((serviceChannels) => {
          serviceChannels.unshift({id: -1, description: 'Atendimento presencial'});
          this.serviceChannels = serviceChannels;
          this.val = serviceChannels[0];
          this.$emit('input', this.val);
        })
        .finally(() => {
        this.loading = false;
        });
    },
  },
  components: {
    MbSelect,
    MbTextButton,
  },
};
</script>
